export const colors = {
  textColor: '#7B7B7B',
  primary: '#FCAB01',
  black: '#3B3B3B',
  navy: '#272F72',
  gray: '#7B7B7B',
  blue: '#0883FA',
  green: '#91EF6A',
};



// WEBPACK FOOTER //
// ./src/themes/colors.js